import React from "react";

/**
 * Sitewide 728x180 advert banner. Rendered inside the top-padded content area of
 * every public page, so it always sits right under the Navbar / Hero.
 */
const AD_URL = "https://8xbet.ng/p/2R16";
const AD_IMG = "/ads/banner-728x180.gif";

const AdvertBanner = ({ className = "" }) => {
  return (
    <div className={`w-full flex justify-center mb-6 ${className}`} data-testid="advert-banner">
      <a
        href={AD_URL}
        target="_blank"
        rel="noopener noreferrer sponsored"
        className="block w-full max-w-[728px] rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-shadow"
        aria-label="Advertisement — opens in a new tab"
        data-testid="advert-banner-link"
      >
        <img
          src={AD_IMG}
          alt="Advertisement"
          width={728}
          height={180}
          loading="lazy"
          className="w-full h-auto block"
        />
      </a>
    </div>
  );
};

export default AdvertBanner;
